import React from "react";
import { format } from "date-fns";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { fullDateFormatWithTime } from "@common/helpers/date";
import {
    EventConnection,
    EventType,
    LogStreamEvent,
} from "@common/types/logStreamEvent";

interface LogStreamEventRowProps {
    log: LogStreamEvent;
}

const eventTypeLabel: Record<EventType, string> = {
    [EventType.LOGIN_FAILED]: "Failed login",
    [EventType.LOGIN_SUCCESS]: "Login",
    [EventType.LOGOUT_SUCCESS]: "Logout",
    [EventType.LOGOUT_FAILED]: "Failed logout",
};

export const LogStreamEventRow: React.FC<LogStreamEventRowProps> = ({
    log,
}) => {
    let label = eventTypeLabel[log.eventType];

    if (
        [EventType.LOGIN_SUCCESS, EventType.LOGIN_FAILED].includes(
            log.eventType,
        )
    ) {
        label += ` (${
            log.connection === EventConnection.SMS ? "phone" : "email"
        })`;
    }

    return (
        <tr className="log-stream-events__row">
            <td>{label}</td>
            <td>
                <Tooltip content={log.userAgent}>
                    <span className="log-stream-events__short">
                        {log.userAgent}
                    </span>
                </Tooltip>
            </td>
            <td>
                <Tooltip content={log.ip}>
                    <span className="log-stream-events__short">{log.ip}</span>
                </Tooltip>
            </td>
            <td>{format(new Date(log.date), fullDateFormatWithTime)}</td>
            <td>{log.ipLocation}</td>
        </tr>
    );
};
